/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { warning } from '../internal/warning.js';

const didWarnAboutDeprecation = {};
function deprecateComponent(componentName, message) {
  if (!componentName) {
    return;
  }
  if (!didWarnAboutDeprecation[componentName]) {
    didWarnAboutDeprecation[componentName] = true;
    process.env.NODE_ENV !== "production" ? warning(false, message || `The ${componentName} component has been deprecated and will be removed in the next major release.`) : void 0;
  }
  return componentName;
}

export { deprecateComponent as default };
